import { Point } from "../primitives"

/**
 * @memberOf Tee.Chart
 * @class Controls how to scroll chart axes by mouse or touch drag.
 * @param {Tee.Chart} chart The parent chart this scroll object belongs to.
 */
export class Scroll {
	constructor(chart) {
		this.chart = chart
		this.active = false
		this.enabled = true
		this.done = false
		this.mouseButton = 2
		this.direction = "both"
		this.position = new Point(0, 0)
	}
}
